import React, { useEffect } from 'react'
import { NavLink, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import logo from '../img/resta-logo.png';
import {useAuth} from '../hooks/appHooks';
import useAxiosFetchApi from '../hooks/useFetch';
import LanguageSelector from '../utils/LanguageSelector';
import {IoArrowBack, IoArrowForward, IoLogOutOutline} from "react-icons/io5"
import { useTranslation } from 'react-i18next';
import AppLoading from '../utils/AppLoading';
import axios from '../apis/axios';
const MAIN_SCREENS_URL = '/screens/role/USER';
const USER_PROFILE_URL = "/exhibitors/profile";
const LOGOUT_URL = "/auth/logout";
const EXHIBITOR_FILES_URL = "/exhibitorFiles/event";

const RequiredAuth = () => {
    const { auth, setAuth } = useAuth();
    const sessionToken = auth.token;
    const [state] = useAxiosFetchApi(USER_PROFILE_URL, {}, sessionToken);
    const [screenState] = useAxiosFetchApi(MAIN_SCREENS_URL, {}, sessionToken);
    const [filesState, setUrl] = useAxiosFetchApi(null, {}, sessionToken);
    const location = useLocation();
    const navigate = useNavigate();
    const{t, i18n} = useTranslation();
    const tMain = t("main")
    const exhibitorProfile = state.data?.data;
    const screens = screenState.data?.list;
    const files = filesState.data?.list;
    
    useEffect(() => {
      setUrl(EXHIBITOR_FILES_URL.concat(`/${exhibitorProfile?.user.event.eventId}`));
      setAuth((prev)=> {return {...prev, exhibitor: exhibitorProfile}});
    }, [setAuth, exhibitorProfile, setUrl])
    useEffect(() => setAuth((prev)=> {return {...prev, files}}), [setAuth, files])


    const handleUserLogout = async (e)=>{
        e.preventDefault();
        const headers= {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${sessionToken}`,
            "Access-Control-Allow-Origin":"*"
        };
        try {
            const response = await axios.get(LOGOUT_URL,{headers});
            console.log(JSON.stringify(response?.data));
            setAuth(null);
            localStorage.removeItem("ecms_token")
            navigate("/login", { replace: true })
        } catch (error) {
            
        }
    }
    return (
        state.isLoading || screenState.isLoading
        ?<AppLoading/>
        : exhibitorProfile && exhibitorProfile.user.username
        ? exhibitorProfile.user.role==="USER"
        ? <div className='flex flex-col cairo-font font-normal'>
            <header className='h-[21%] border-b border-dashed border-primary-color'>
                <div className='flex shadow-2 fixed w-full bg-white'>
                    <div className='w-20 py-2 bg-primary-color'>
                        <img src={logo} width={70} alt='logo' />
                    </div>
                    <div className='flex justify-end items-center w-full'>
                        <p className='font-semibold mx-5'><span className='font-normal'>{tMain.exhibitorTxt}: <b>{exhibitorProfile.user.username}</b></span></p>
                        <p className='font-semibold mx-5'><span className='font-normal'>{tMain.standNoTxt}: <b>{exhibitorProfile.standNumber}</b></span></p>
                        <LanguageSelector/>
                        <button className='flex mx-1 bg-white' onClick={handleUserLogout}>
                            {tMain.logoutNavBtn}
                            <IoLogOutOutline className='ms-3 size-6'/>
                        </button>
                        <button className='flex mx-2 bg-white' onClick={()=>navigate(-1)}>
                            {"رجوع"}
                            {i18n.language==="ar"
                            ? <IoArrowBack className='ms-3 mt-1 size-6'/>
                            : <IoArrowForward className='ms-3 mt-1 size-6'/>}
                        </button>
                    </div>
                </div>
                {!screens?"Loading...":<nav className={`flex justify-center scrollbar-custom mt-24 mb-3 mx-3 py-3 text-sm`}>
                    {screens.slice(0, screens.length).map((navigator) =>
                        <NavLink className="w-2/12 whitespace-nowrap text-center font-bold" key={navigator.screenId} to={navigator.route}>{i18n.language==="en"?navigator.enTitle:navigator.arTitle}</NavLink>
                    )}
                </nav>}
            </header>
            <main className='w-full container mx-auto my-8'>
                {/* <ScreenContentProvider> */}
                <Outlet context={screens}/>
                {/* </ScreenContentProvider> */}
            </main>
            {/* <footer className='self-stretch h-[200px] w-full bg-slate-800 mx-auto mt-6'>Footer</footer> */}
        </div>
        : <Navigate to="/unauthorized" state={{ from: location }} replace />
        : <Navigate to="/login" state={{ from: location }} replace />
    )
}

export default RequiredAuth